import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { features } from 'reactApp/mail-features';

/**
 * CLOUDWEB-19209
 * Доступности чистилки для платных пользователей
 */

export const isQuotaCleanerEnabledForPaid = isFeature('quota-cleaner-for-paid');

export const quotaCleanerByLink = features.has('quota-cleaner-by-link');
